//Styles
import { useEffect } from "react";
import { APP_KEY_IDS, aboutSystemInformation } from "../../constants/constants";
import Styles from "./AboutSystem.module.scss";
import classnames from "classnames";
import { useDispatch } from "react-redux";
import { closeWindow } from "../../actions";

//Redux


const AboutSystem = () => {

    const dispatch = useDispatch()

  return (
    <div className={Styles.container}>
        <div className={classnames(Styles.about_container,"glassBackground")}>
            <div className={Styles.left_container}>
                <div className={Styles.profile_image}/>
            </div>
            <div className={Styles.right_container}>
                <div className={Styles.title}>macOS Moneterey</div>
                <div className={Styles.information_container}>
                    {aboutSystemInformation.map((info)=>{
                        return(
                            <div className={Styles.info_text}>
                                {info.key} : {info.value}
                            </div>
                        )
                    })
                    }
                </div>
                <div className={Styles.buttons}>

                        <div className={classnames(Styles.button)} onClick={()=>{dispatch(closeWindow(APP_KEY_IDS.ABOUT_SYSTEM))}} >
                            Ok
                        </div>
                        <div className={classnames(Styles.button,Styles.disabled)}>
                            Software Update
                        </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default AboutSystem
